import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Lockr from 'lockr';
import DownLoad from '@/components/Download';
import {
  callNativeFunction,
  nativeFunction,
} from '@/utils/detectDevice';
import { STORAGE_KEY } from '@/constants';
import useSoundEffect from '../hooks/useSoundEffect';

const Resource = ({ book, history }) => {
  const [downloadedBookSize, setDownloadedBookSize] = useState(0);
  const [isChecklocalData, setIsChecklocalData] = useState(false);
  const [needDownloadBook, setNeedDownloadBook] = useState(false);
  const [progress, setProgress] = useState(0);
  const [bookDownloaded, setBookDownloaded] = useState(false);


  const {
    downlodedSoundEffectSize,
    isDownloadedSoundEffect,
    SOUNDS_SIZE,
  } = useSoundEffect();

  useEffect(() => {
    callNativeFunction(nativeFunction.CHECK_LOCAL_DATA)();
    window.onfire.on('setDownloaded', ({ downloaded: arr }) => {
      setNeedDownloadBook(!arr.includes(book.name));
      setIsChecklocalData(true);
    });
    return () => window.onfire.off('setDownloaded');
  }, [book.name]);

  const isSoundEffectDownloaded = () => (isDownloadedSoundEffect && downlodedSoundEffectSize > 0);

  useEffect(() => {
    if (isSoundEffectDownloaded() && isChecklocalData) {
      if (needDownloadBook) {
        callNativeFunction(nativeFunction.DOWNLOAD_BOOK)({
          book: book.name,
          pages: book.pages,
          size: book.size,
        });
        window.onfire.on('setDownloadBookProgress', ({ current }) => {
          console.log('setDownloadBookProgress', current);
          setDownloadedBookSize(current);
        });
      } else {
        setProgress(100);
      }
    }
    return () => window.onfire.off('setDownloadBookProgress');
  }, [isDownloadedSoundEffect, isChecklocalData]);

  const countProgress = () => (
    (downlodedSoundEffectSize + downloadedBookSize) / (SOUNDS_SIZE + book.size)
  );
  useEffect(() => {
    setProgress((countProgress() * 100).toFixed(2));
  }, [downlodedSoundEffectSize, downloadedBookSize]);

  useEffect(() => {
    setBookDownloaded(parseInt(progress, 10) === 100);
  }, [progress]);

  const doRoute = () => {
    const url = `/cover/${book.id}/${book.attempt}/${book.stage}/${book.stageId}`;
    window.bookFromHomeWork = true;
    history.push(url);
    // console.log(url, history);
  };

  const setPageXml = (json) => {
    Lockr.set(STORAGE_KEY.PAGES, json);
    doRoute();
  };

  const callback = () => {
    callNativeFunction(nativeFunction.BACK)({});
  };

  useEffect(() => {
    if (bookDownloaded) {
      callNativeFunction(nativeFunction.ENTRANCE_BOOK)({
        name: book.name,
      });
      window.onfire.on(`entrance-${book.name}`, (pages) => {
        setPageXml(pages);
      });
    }
    return () => window.onfire.off(`entrance-${book.name}`);
  }, [bookDownloaded]);

  return (
    <div className="cover-bg">
      <div className="cover-container">
        <div className="cover-content-gray">
          <div className="book-title" />
        </div>
        <div className="book-pedestal" />
        <div className="book-introduce" />
        <div className="unstart">start</div>
      </div>

      <DownLoad progress={Number(progress)} isReturnTo goBackTo={callback} />
    </div>
  );
};

Resource.propTypes = {
  history: PropTypes.object,
  book: PropTypes.object,
};

export default Resource;
